import { createSlice } from '@reduxjs/toolkit';
import { tabRoutes } from '../../routes';

const processInitialTabsState = () => {
	const disabledTabs = {};

	tabRoutes.forEach(route => {
		disabledTabs[route.name] = route.disabled;
	});

	return disabledTabs;
};

const tabbarSlice = createSlice({
	name: 'tabbar',
	slice: 'tabbar',
	initialState: {
		activeTab: 0,
		disabledTabs: processInitialTabsState(),
		progressActive: true
	},
	reducers: {
		activateTab(state, action) {
			state.progressActive = true;
			state.activeTab = action.payload;
		},
		enableSelectTab(state) {
			state.disabledTabs.Select = false;
		},
		enableDesignTabs(state) {
			Object.keys(state.disabledTabs).forEach(tab => tab !== 'Select' && (state.disabledTabs[tab] = false));
		},
		setProgressActive(state, action) {
			state.progressActive = action.payload;
		}
	}
});

export default tabbarSlice;
